export enum FiltersName {
  BillNumber = 'billNum',
  Cups = 'cups'
}